import { createActions } from 'redux-actions';

import types from 'state/warnings/actionTypes';

const { warnings } = createActions({
  [types.SET_WARNING]: (wrngs) => ({ warnings: wrngs }),
  [types.REMOVE_WARNING]: (wrngs) => ({ warnings: wrngs }),
  [types.CLEAN_WARNINGS]: () => ({}),
});

export default warnings;
